import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import Image from '../Image';

const UspImageText = ({ text, textMobile, textSize, textColor, className, icon, image }) => {
    const baseClass = 'flex flex-col items-center text-center';
    const rootClass = cx(baseClass, className);

    return (
        <div className={rootClass}>
            {icon}
            {image && (
                <div className='w-[30px] sm:w-[48px]'>
                    <Image
                        layout='fixed'
                        width={48}
                        height={48}
                        src={image.logoUrl}
                        alt={image.value}
                    />
                </div>
            )}
            <p
                className={cx('mb-0 mt-2.5 font-body', {
                    [textColor]: textColor,
                    [textSize]: textSize,
                    'text-caption xl:text-small': !textSize,
                })}
            >
                {text && (
                    <span
                        className={cx({
                            'hidden xl:block': textMobile,
                            block: !textMobile,
                        })}
                    >
                        {text}
                    </span>
                )}
                {textMobile && <span className='block xl:hidden'>{textMobile}</span>}
            </p>
        </div>
    );
};

UspImageText.displayName = 'UspImageText';

UspImageText.defaultProps = {};

UspImageText.propTypes = {
    text: PropTypes.string,
    textMobile: PropTypes.string,
    textColor: PropTypes.string,
    textSize: PropTypes.string,
    icon: PropTypes.object,
    image: PropTypes.shape({
        logoUrl: PropTypes.string,
        value: PropTypes.string,
    }),
    className: PropTypes.string,
};

export default UspImageText;
